<div class="p-6">
  <h2 class="title-t2 primary-text mb-4">{{ (isEdit ? 'documentTypeRoleConfigs.editTitle' : 'documentTypeRoleConfigs.newTitle') | translate }}</h2>

  <form [formGroup]="form">
    <div class="form-container__form-field flex flex-col w-full mb-4">
      <mat-label class="label mb-1">{{ 'documentTypeRoleConfigs.documentType' | translate }}</mat-label>
      <mat-form-field>
        <mat-select formControlName="documentType">
          <mat-option *ngFor="let dt of documentTypes" [value]="dt">
            {{ 'objects.' + dt | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-container__form-field flex flex-col w-full mb-4">
      <mat-label class="label mb-1">{{ 'actorDocuments.roles.issuer' | translate }}</mat-label>
      <mat-form-field>
        <mat-select formControlName="issuerTypes">
          <mat-option [value]="null">—</mat-option>
          <mat-option *ngFor="let at of getFilteredActorTypes('issuer')" [value]="at">{{ 'objects.' + at | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-container__form-field flex flex-col w-full mb-4">
      <mat-label class="label mb-1">{{ 'uploadDocuments.receivers' | translate }}</mat-label>
      <mat-form-field>
        <mat-select formControlName="receiverTypes" multiple>
          <mat-option *ngFor="let at of getFilteredActorTypes('receiver')" [value]="at">{{ 'objects.' + at | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-container__form-field flex flex-col w-full mb-4">
      <mat-label class="label mb-1">{{ 'uploadDocuments.related' | translate }}</mat-label>
      <mat-form-field>
        <mat-select formControlName="relatedTypes" multiple>
          <mat-option *ngFor="let at of getFilteredActorTypes('related')" [value]="at">{{ 'objects.' + at | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>

  <div class="flex justify-end gap-4 mt-4">
    <app-button-link (click)="cancel()" text="{{ 'buttons.cancel' | translate }}"></app-button-link>
    <app-button-secondary (click)="save()">{{ 'buttons.save' | translate }}</app-button-secondary>
  </div>
</div>
